// extracted by mini-css-extract-plugin
export default {"root":"VUt5H8"};